import {
  PasswordField,
  TextField,
  formFieldRequiredLabel as requiredLabel,
} from '@elementary/common-ui/components';
import FormControls from '@elementary/common-ui/components/FormControls';
import { UseFormReturn } from 'react-hook-form';
import { ThoughtSpotForm as ThoughtSpotFormFields } from 'shared/types';

const ThoughtSpotForm = ({
  formMethods,
}: {
  formMethods: UseFormReturn<ThoughtSpotFormFields, any, undefined>;
}) => {
  const {
    register,
    formState: { errors, dirtyFields },
    setValue,
  } = formMethods;

  return (
    <>
      <FormControls.InputWrapper>
        <TextField
          {...register('thoughtSpotConnectionName', {
            required: requiredLabel,
          })}
          variant="outlined"
          label="Connection name"
          size="large"
        />
        <FormControls.ErrorMessage>
          {errors.thoughtSpotConnectionName?.message}
        </FormControls.ErrorMessage>
      </FormControls.InputWrapper>

      <FormControls.InputWrapper>
        <TextField
          {...register('thoughtSpotUsername', {
            required: requiredLabel,
          })}
          variant="outlined"
          label="Username"
          size="large"
        />
        <FormControls.ErrorMessage>
          {errors.thoughtSpotUsername?.message}
        </FormControls.ErrorMessage>
      </FormControls.InputWrapper>
      <FormControls.InputWrapper>
        <PasswordField
          {...register('thoughtSpotSecretKey', {
            required: requiredLabel,
          })}
          label="Secret key"
          isFormValueDirty={dirtyFields.thoughtSpotSecretKey}
          clearFormValue={() => setValue('thoughtSpotSecretKey', '')}
          size="large"
        />
        <FormControls.ErrorMessage>
          {errors.thoughtSpotSecretKey?.message}
        </FormControls.ErrorMessage>
      </FormControls.InputWrapper>
      <FormControls.InputWrapper>
        <TextField
          {...register('thoughtSpotBaseUrl', {
            required: requiredLabel,
          })}
          variant="outlined"
          label="Base URL"
          placeholder="e.g. https://team1.thoughtspot.cloud"
          size="large"
        />
        <FormControls.ErrorMessage>
          {errors.thoughtSpotBaseUrl?.message}
        </FormControls.ErrorMessage>
      </FormControls.InputWrapper>
    </>
  );
};

export default ThoughtSpotForm;
